var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9999 0.150391C4.44808 0.150391 1.49969 2.48147 0.203545 5.72185C0.132022 5.90066 0.132022 6.10013 0.203545 6.27893C1.49969 9.51931 4.44808 11.8504 7.9999 11.8504C11.5517 11.8504 14.5001 9.51931 15.7963 6.27893C15.8678 6.10013 15.8678 5.90066 15.7963 5.72185C14.5001 2.48147 11.5517 0.150391 7.9999 0.150391ZM7.9999 10.3504C5.24863 10.3504 2.86739 8.60649 1.71357 6.00039C2.86739 3.3943 5.24863 1.65039 7.9999 1.65039C10.7512 1.65039 13.1324 3.3943 14.2862 6.00039C13.1324 8.60648 10.7512 10.3504 7.9999 10.3504ZM6.54987 6.00039C6.54987 5.19958 7.19905 4.55039 7.99987 4.55039C8.80068 4.55039 9.44987 5.19958 9.44987 6.00039C9.44987 6.8012 8.80068 7.45039 7.99987 7.45039C7.19905 7.45039 6.54987 6.8012 6.54987 6.00039ZM7.99987 3.05039C6.37063 3.05039 5.04987 4.37115 5.04987 6.00039C5.04987 7.62963 6.37063 8.95039 7.99987 8.95039C9.62911 8.95039 10.9499 7.62963 10.9499 6.00039C10.9499 4.37115 9.62911 3.05039 7.99987 3.05039Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ee3ad09b700cf90bf368908863c4818e.svg";
export { ForwardRef as ReactComponent };